export const CardExpenseChart = {
    series: [100, 55, 41, 17],
    labels: ['Team A', 'Team B', 'Team C', 'Team D'],
    chart: {
        type: 'donut',
        height: 300,
    },
    legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: "16px",
    },
    dataLabels: {
        enabled: false
    },

};